import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledModalCalendarContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  width: '450px',
});
